import type { CSSProperties } from 'react';
import { intakeFlags, templateCodeOf } from '../logic/task';
import { isCheckinTask } from '../logic/checkin';

interface FlaggedTask {
  template?: { template_code?: string } | null;
  template_code?: string | null;
  context_json?: unknown;
}

// Mounted on BOTH task surfaces (drawer + patient-file card): the flags are why WF52's and WF78's tasks exist.
export default function TaskIntakeFlags({ task, style }: { task: FlaggedTask; style?: CSSProperties }) {
  const flags = [...new Set(intakeFlags(task))];
  if (!flags.length) return null;
  const heading = isCheckinTask(templateCodeOf(task)) ? 'From the check-in' : 'Intake flags';
  return (
    <div style={{ margin: '6px 0 0', ...style }}>
      <span className="detail1" style={{ fontWeight: 600, fontSize: 11, color: 'var(--wi-text-primary-moderate)' }}>
        {heading}
      </span>
      <ul aria-label={heading} className="detail1 text-secondary" style={{ margin: '2px 0 0', paddingLeft: 16, lineHeight: 1.45 }}>
        {flags.map((f) => <li key={f}>{f}</li>)}
      </ul>
    </div>
  );
}
